<template>
	<v-row align="center" align-content="center" class="justify-start" wrap style="width: 100%">
		<v-col cols="auto" class="py-lg-0 d-flex flex-column justify-start pe-lg-0" v-if="on_lg && $i18n.locale !== 'es'">
			<v-btn
				color="displayingColor white--text"
				@click="back()"
				class="d-flex align-items-center"
				:disabled="disabled || backDisable"
			>
				<v-icon small>fa fa-arrow-circle-right</v-icon>
				<span class="ps-1 mb-1">{{$t('previous')}}</span>
			</v-btn>
		</v-col>
		<v-col cols="auto" class="py-lg-0 d-flex flex-column pe-lg-0" v-if="on_lg && $i18n.locale !== 'es'">
			<v-btn
				color="displayingColor white--text"
				class="d-flex align-items-center"
				:disabled="disabled || nextDisable"
				@click="next()"
			>
				<span class="pe-1 mb-1">{{$t('next')}}</span>
				<v-icon small>fa fa-arrow-circle-left</v-icon>
			</v-btn>
		</v-col>

		<v-col cols="auto" class="d-flex justify-start align-center" :class="on_lg ? '' : 'ps-3'">
			<v-btn
				v-if="!on_lg || $i18n.locale === 'es'"
				color="displayingColor white--text"
				@click="back()"
				class="d-flex align-items-center me-3"
				:disabled="disabled || backDisable"
			>
				<v-icon small>fa fa-arrow-circle-right</v-icon>
			</v-btn>
			<v-btn
				v-if="!on_lg || $i18n.locale === 'es'"
				color="displayingColor white--text"
				class="d-flex align-items-center me-3"
				:disabled="disabled || nextDisable"
				@click="next()"
			>
				<v-icon small>fa fa-arrow-circle-left</v-icon>
			</v-btn>
			<bee-text-field
				v-model.number="localValue"
				:label="label"
				hide-details="true"
				@keydown-enter-prevent="$emit('keydown-enter-prevent', localValue)"
				context="bond"
				:action-name="actions.GET"
				style="width: fit-content; max-width: 70px;"
			></bee-text-field>
		</v-col>
	</v-row>
</template>
<script>
import actions from "../../../../permissions/actions-names.js";
export default {
    name: "BeeBondUpDown",
    
    props: ["label", "items", "value", "disabled"],

    data: () => ({
		actions,
		nextDisable: false,
		backDisable: false
	}),

	computed: {
		localValue: {
			get: function() {
				return this.value;
			},
			set: function(value) {
				this.$emit("input", value);
			}
		},
		on_lg() {
			return this.$vuetify.breakpoint.lg;
		}
    },
    watch: {
		localValue(val) {
			if(Array.isArray(this.items)) {
				if(val === this.items[this.items.length - 1] && val === this.items[0]) {
					this.nextDisable = true;
					this.backDisable = true;
				} else if(val === this.items[this.items.length - 1]) {
					this.nextDisable = true;
					this.backDisable = false;
				} else if(val === this.items[0]) {
					this.nextDisable = false
					this.backDisable = true;
				} else {
					this.nextDisable = false;
					this.backDisable = false
				}
			}
		}
	},
	methods: {
		next() {
			if (this.items) {
				const step = 1;
				let current_index = this.items.indexOf(this.localValue);
				let next_index = current_index + step;
				if (next_index <= this.items.length - 1) {
					this.localValue = this.items[next_index];
					this.$emit("programmatically-changed");
				}
			}
		},
		back() {
			if (this.items) {
				const step = 1;
				let current_index = this.items.indexOf(this.localValue);
				let previous_index = current_index - step;
				if (previous_index >= 0) {
					this.localValue = this.items[previous_index];
					this.$emit("programmatically-changed");
				}
			}
		}
    },
    
    mounted() {
		if (this.items && !this.value)
			this.localValue = this.items[this.items.length - 1];
	},

	i18n:{
		messages :{
			ar: { 'previous': 'سابق', 'next': 'تالي' },
			en: { 'previous': 'Previous', 'next': 'Next' },
			es: { 'previous': 'Anterior', 'next': 'Próximo' },
		}
	}
};
</script>
<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
	margin-bottom: 0px !important;
}
</style>